<app-users-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-users-filters>

<mat-card class="add-button-container" *ngIf="!(users | async)?.length">
  <h4>Nessun utente trovato</h4>
  <button class="add-button" *ngIf="canAdd" mat-raised-button (click)="addUser()" color="primary">
    Aggiungi
  </button>
</mat-card>

<div class="table-container" [hidden]="!(users | async)?.length">
  <table mat-table matSort [dataSource]="users" multiTemplateDataRows matSortDisableClear matSortActive="name"
    matSortDirection="asc">

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nome </th>
      <td mat-cell *matCellDef="let element"> {{ element.name }} {{ element.surname }} </td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element"> {{ element.email }} </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Telefono </th>
      <td mat-cell *matCellDef="let element"> {{ element.phone || 'N/A' }} </td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef> Ruolo </th>
      <td mat-cell *matCellDef="let element"> {{ element.role }} </td>
    </ng-container>


    <ng-container matColumnDef="tenant">
      <th mat-header-cell *matHeaderCellDef> Punto Vendita </th>
      <td mat-cell *matCellDef="let element">
        {{ getTenantsList(element) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="add-icon-container">
        <button  mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo utente"
          (click)="$event.stopPropagation(); addUser()" color="primary">
          <mat-icon>add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row" class="modify-icon-container">
        <ng-container *ngIf="canEdit">
          <button mat-icon-button (click)="$event.stopPropagation(); editUser(row)">
            <mat-icon matTooltip="Modifica">create</mat-icon>
          </button>
        </ng-container>

        <button *ngIf="canSelect" mat-raised-button color="primary" (click)="selectUser(row)">
          Seleziona
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editUser(row)"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSizeOptions[0]"
    [length]="total | async">
  </mat-paginator>
</div>
